import { render, staticRenderFns } from "./NewsItemList.vue?vue&type=template&id=6db8883d"
import script from "./NewsItemList.vue?vue&type=script&lang=js"
export * from "./NewsItemList.vue?vue&type=script&lang=js"
import style0 from "./NewsItemList.vue?vue&type=style&index=0&id=6db8883d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports